export default {
    farm: {
        locationType: "Jenis Lokasi",
        viewLocation: "Lihat Lokasi",
        Circular: "Melingkar",
        Polygon: "Poligon",
        farmerId: "ID Petani",
        farmAddress: "Alamat Lokasi Perkebunan",
        farmID: "ID Perkebunan",
        farmIdPlaceHolder: "Masukkan ID Perkebunan",
        onTheFarm: "Di Perkebunan",
        userRoles: "Peran Pengguna",
        adduser: "Tambah Pengguna",
        addAuser: "Tambah Pengguna",
        uploadUsers: "Unggah Pengguna",
        addNewUser: "Tambah Pengguna Baru",
        selectDept: "Pilih Departemen",
        selectRole: "Pilih Peran",
        editUser: "Edit Pengguna",
        totalFarms: "Total Perkebunan",
        NoAnimalsRegisteredForthisFarm:
          "Tidak ada hewan yang terdaftar untuk perkebunan ini",
        farmsPerPage: "Perkebunan per Halaman",
        regularFarms: "Perkebunan Reguler",
        farmRegisteredProducts: "Produk Terdaftar Perkebunan",
        searchByFarmNameAndId: "Cari berdasarkan Nama Perkebunan dan ID",
        loadingProductsPleaseWait: "Memuat Produk... Mohon tunggu",
        farmName: "Nama Perkebunan",
        nameOfTheFarm: "Nama Perkebunan",
        farmLocation: "Lokasi Perkebunan",
        productName: "Nama Produk",
        stockStatus: "Status Stok",
        inStock: "Tersedia",
        searchByProductName: "Cari Berdasarkan Nama Produk",
        productCategory: "Kategori Produk",
        products: "Produk",
        farms: "Perkebunan",
        zones: "Zona",
        registerAfarm: "Daftarkan Perkebunan",
        govtRegistry: "Registrasi Pemerintah",
        cooperativeId: "ID Koperasi/Uni",
        cooperativeName: "Nama Koperasi/Uni",
        factory: "Pabrik",
        farmType: "Tipe Perkebunan",
        contractMating: "Pembiakan Kontrak",
        customization: "Penyesuaian",
        recordsPerpage: "Rekaman per Halaman",
        restoreDefault: "Pulihkan Default",
        apply: "Terapkan",
        CommunityName: "Nama Komunitas",
        corporateName: "Nama Perusahaan",
        corporateRegistrationNum: "Nomor Registrasi Perusahaan",
        communityName: "Nama Komunitas",
        searchState:
          "Cari berdasarkan ID Perkebunan, Registrasi Pemerintah, ID Koperasi, Tipe Perkebunan, Pembiakan Kontrak",
        farmOwner: "Pemilik Perkebunan",
        govRegistrationNo: "Nomor Registrasi Pemerintah",
        farmInformation: "Informasi Perkebunan",
        ownershipType: "Tipe Kepemilikan",
        farmLicenseInformation: "Informasi Lisensi Perkebunan",
        licenseNumber: "Nomor Lisensi",
        licenseExpiryDate: "Tanggal Kadaluarsa Lisensi",
        regulatorName: "Nama Regulator",
        regulatorRepresentativeName: "Nama Perwakilan Regulator",
        farmLocationSize: "Lokasi & Ukuran Perkebunan",
        productionSystem: "Sistem Pertanian",
        productionSystemNew: "Sistem Produksi",
        goals: "Tujuan",
        country: "Negara",
        state: "Provinsi",
        city: "Desa/Kota",
        gpsLocation: "Lokasi GPS",
        latitude: "Lintang",
        longitude: "Bujur",
        farmNumber: "Nomor Perkebunan",
        postal: "Kode Pos",
        houseNumber: "Nomor Rumah",
        farmRegistration: "Registrasi Perkebunan",
        cancel: "Batal",
        register: "Daftar",
        ok: "OK",
        totalFarmSize: "Total Ukuran Perkebunan",
        farmGeographicLocation: "Lokasi Geografis Perkebunan",
        perimeterPointLongitude: "Bujur Titik Perimeter",
        perimeterPointLatitude: "Lintang Titik Perimeter",
        perimeterPointLabel: "Label Titik Perimeter",
        perimeterLength: "Panjang Perimeter",
        farmLatitude: "Lintang Perkebunan",
        farmLongitude: "Bujur Perkebunan",
        editFarm: "Edit Perkebunan",
        update: "Perbarui",
        editAfarm: "Edit Perkebunan",
        nextFarm: "Perkebunan Berikutnya",
        nameoftheFarm: "Nama Perkebunan",
        addNewLocation: "Tambah Lokasi Baru",
        registerAProduct: "Daftarkan Produk",
        farmProducts: "Produk Perkebunan",
        calf: "Anak Sapi",
        steer: "Sapi Jantan",
        heifer: "Sapi Betina",
        sire: "Sapi Pejantan",
        dam: "Sapi Induk",
        registerAnAnimal: "Daftarkan Hewan",
        farmAnimals: "Hewan Perkebunan",
        farm_type: "Tipe Perkebunan",
        farm_Owner: "Pemilik Perkebunan",
        dateOfRegistration: "Tanggal Pendaftaran",
        dataIsNotAvailableForThisFarm: "Data Tidak Tersedia untuk Perkebunan Ini",
        registerNewProduct: "Daftarkan Produk Baru",
        information: "Informasi",
        licenseInfo: "Info Lisensi",
        locationInfo: "Info Lokasi",
        geoLocation: "Lokasi Geografis",
        perimeterLengthState: "Panjang Perimeter Perkebunan (Panjang Pagar)",
        totalFarmSizeState: "Ukuran Perkebunan",
        productionSystemState: "Sistem Produksi yang Digunakan di Perkebunan",
        contractMatingState:
          "Kode Program Pembiakan Kontrak yang Diikuti Perkebunan",
        ownershipTypeState: "Tipe Kepemilikan",
        regulatorRepresentativeNameState:
          "Nama Perwakilan Regulator yang Menerbitkan Lisensi",
        regulatorNameState: "Nama Regulator yang Menerbitkan Lisensi",
        licenseExpiryDateState: "Tanggal Kadaluwarsa Lisensi Saat Ini",
        licenseNumberState: "Nomor Lisensi yang Dikeluarkan oleh Regulator",
        plotNumberState: "Nomor Rumah Perkebunan",
        plotNumber: "Nomor Perkebunan",
        streetStatement: "Nama Jalan Perkebunan",
        cityStatement: "Kota Tempat Perkebunan Berlokasi",
        farmLocationAddressInfo:
          "Tempat Utama Perkebunan Melakukan Aktivitas Pertanian",
        provinceStateInfo:
          "Pembagian Administratif Utama di Negara atau Kekaisaran",
        cityInfo:
          "Pemukiman Manusia Terkonsentrasi atau Komunitas dan Bangunan Terkait, Lebih Besar dari Pemukiman Kecil dan Lebih Kecil dari Kota, Terletak di Daerah Pedesaan",
        streetNumberInfo: "Nomor Jalan",
        totalFarmSizeInfo: "Ukuran Total Perkebunan",
        areaUOMInfo:
          "Unit Pengukuran untuk Ukuran Perkebunan (misalnya, Hektar, Acre, dll.)",
        perimeterLengthInfo: "Total Panjang Perimeter Perkebunan",
        permiterUOMInfo:
          "Unit Pengukuran untuk Perimeter Perkebunan (misalnya, Sentimeter, Meter, dll.)",
        stateStatement: "Wilayah Negara Tempat Perkebunan Berlokasi",
        countryState: "Negara Tempat Perkebunan Berlokasi",
        farmStateInfo: "Alamat Lokasi Perkebunan",
        perimeterPointLongitudeState: "Garis Bujur Satu Titik di Perkebunan",
        perimeterPointLatitudeState: "Garis Lintang Satu Titik di Perkebunan",
        perimeterPointLabelState: "Label Titik",
        farmLongitudeState: "Garis Bujur Perkebunan",
        farmLatitudeState: "Garis Lintang Perkebunan",
        deleteFarm: "Hapus Perkebunan",
        farmNameH: "Nama Perkebunan",
        farmTypeH: "Tipe Perkebunan yang Melakukan Berbagai Aktivitas",
        farmOwnerH:
          "Nama Pemilik Perkebunan (Auto-generate Nama Petani Memasukkan Info)",
        ownershipTypeH:
          "Jenis Petani yang Memiliki/Mengontrol Tanah yang Mereka Tanami dan Mereka yang Tidak",
        govtRegNumbH: "Nomor Registrasi Perkebunan yang Ditetapkan oleh Regulator",
        contractMatingH: "Kode Program Pembiakan Kontrak yang Diikuti Perkebunan",
        productionSystemH: "Sistem Produksi yang Digunakan di Perkebunan",
        cooperativeIDH: "ID dari Koperasi yang Menjadi Anggota Perkebunan",
        licenseNumberH:
          "Nomor Identifikasi pada Lisensi yang Dikeluarkan oleh Regulator yang Mengidentifikasikannya dengan Pemilik",
        licenseExpiryDateH: "Tanggal Kadaluwarsa Lisensi Saat Ini",
        regularNameH: "Nama Regulator yang Menerbitkan Lisensi",
        regularRepName:
          "Nama Orang yang Mewakili Regulator yang Menerbitkan Lisensi",
        countryH: "Negara Tempat Perkebunan Berlokasi",
        stateH: "Wilayah Negara Tempat Perkebunan Berlokasi",
        cityH: "Kota Tempat Perkebunan Berlokasi",
        streetH: "Nama Jalan Perkebunan",
        houseNumberH: "Nomor Rumah Perkebunan",
        totalFarmSizeH:
          "Ukuran Perkebunan adalah Jumlah Lahan yang Saat Ini Ditanami oleh Perkebunan Termasuk Lahan yang Sedang Fallow tetapi Tidak Termasuk Lahan di Bawah Vegetasi Alami, Pohon atau Padang Rumput",
        farmLatitudeH:
          "Pengukuran Jarak ke Utara atau Selatan Khatulistiwa, Diukur dengan 180 Garis Imajiner yang Membentuk Lingkaran di Sekitar Bumi Timur-Barat, Paralel dengan Khatulistiwa",
        farmLongitudeH: "Pengukuran Jarak ke Timur atau Barat dari Meridian Utama",
        perimeterLengthH: "Panjang Perimeter Perkebunan (Panjang Pagar)",
        perimeterPointLabelH:
          "Label Titik untuk Mendeskripsikan Perimeter Perkebunan dan Segmen Apa pun di Dalam Perkebunan",
        perimeterPointLatH: "Garis Lintang Satu Titik di Perkebunan",
        perimeterPointLongH: "Garis Bujur satu titik di perkebunan",
        street: "Jalan",
        registration: {
          regulatorName: "Nama regulator yang mengeluarkan lisensi",
          perimeterPointLabel:
            "Label titik. Menggunakan tiga parameter (lintang, bujur, dan label) kita mendeskripsikan sekeliling perkebunan dan segmen di dalamnya.",
          perimeterPointLatitude: "Lintang titik sekeliling",
          perimeterPointLongitude: "Bujur titik sekeliling",
          farmID: "Nomor Identifikasi diberikan kepada perkebunan ternak",
          farmName: "Nama yang diberikan kepada perkebunan ternak",
          CommunityName:
            "Nama yang diberikan kepada kelompok orang dengan karakteristik atau minat bersama tinggal bersama dalam masyarakat yang lebih besar",
          farmType:
            "Tipe perkebunan dapat diklasifikasikan (dikelompokkan) menurut ternak yang dibesarkan dan bagaimana cara dibesarkan",
          farmOwner:
            "Setiap orang yang memiliki atau mengendalikan operasi perkebunan",
          ownershipType:
            "Jenis petani yang memiliki/mengontrol perkebunan dan mereka yang tidak",
          govtRegistrationNumber:
            "Nomor yang diberikan oleh organisasi pemerintah di mana perkebunan terdaftar",
          licenseNumber: "Nomor lisensi yang dikeluarkan oleh regulator",
          licenseExpiryDate: "Tanggal lisensi tidak berlaku lagi untuk diakui",
          regulatorRepresentativeName: "Nama Perwakilan Regulator",
        },
        addFarm: "Tambahkan Perkebunan",
        importFarmsInBulk: "Impor Perkebunan Massal",
        importFarms: "Impor Perkebunan",
        importingNote:
          "File yang diunggah sedang diproses.\nJangan klik batal, tutup, atau refresh halaman ini untuk menghindari gangguan.",
        bulkImportNote:
          "Unduh dan gunakan template di bawah untuk impor massal perkebunan.",
    
        importantNote: "Catatan Penting",
        selectFileToUpload: "Pilih file untuk mengunggah data",  
        importantNoteDetail: "Harap gunakan template yang disediakan di atas untuk unggahan massal. Format lain akan mengakibatkan kegagalan.",
        importCompleted: "Impor Selesai",
        farmerFirstName: "Nama Depan Petani",
        farmerMiddleName: "Nama Tengah Petani",
        farmerLastName: "Nama Belakang Petani",
        iAmNotFarmer: "Saya bukan petani",
        certifications: "Sertifikasi",
        productionType: "Tipe Produksi",
        deleted: "Perkebunan berhasil dihapus.",
        notDeleted: "Perkebunan tidak berhasil dihapus.",
        farmTitleDocument: "Dokumen Judul Perkebunan",
        dropHere: "atau seret dan lepas di sini",
        technicianName: "Nama Teknisi",
    
        farmRegistrationId: "ID Registrasi Perkebunan",
        farmerRegistrationId: "ID Registrasi Petani",
        farmId: "ID Perkebunan",
        farmerName: "Nama Petani",
        farmOwnershipType: "Tipe Kepemilikan Petani",
        farmGoals: "Tujuan Perkebunan",
        farmCertifications: "Sertifikasi Perkebunan",
        farmInfo: "Informasi Perkebunan",
        provinceState: "Provinsi/Negara Bagian",
        streetNumber: "Nomor Jalan",
        addGeofenceForThisFarm: "Tambahkan geofence untuk perkebunan ini",
        pleaseClickToChooseLocation: "Klik untuk memilih lokasi",
        address: "Alamat",
        geographicLocation: "Lokasi Geografis",
        searchLocation: "Cari Lokasi",
        pleaseChooseOneOfTheOption: "Silakan pilih salah satu opsi",
        useGeoFencingFeature: "Gunakan fitur geofencing",
        uploadShapeFile: "Unggah file bentuk",
        uploadGeofence: "Unggah Geofence",
        upload: "Unggah",
        reports: "Laporan",
        avocado: "Alpukat",
        avocadoTrees: "Pohon Alpukat",
        addNewFarmLocation: "Tambahkan Lokasi Perkebunan Baru",
        farmLocationAddress: "Alamat Lokasi Perkebunan",
        useGeofenceTool: "Gunakan alat geofencing",
        geofenceIsRequiredForSatelliteReport:
          "Catatan: Geofence diperlukan untuk Laporan Satelit",
        enterHere: "Masukkan di sini",
        primaryLocation: "Lokasi Utama",
        secondaryLocation: "Lokasi Sekunder",
        locationAndSize: "Lokasi dan Ukuran",
        addNewZone: "Tambahkan Zona Baru",
        noZoneMessage: "Belum ada zona yang terdaftar.",
        noZoneRequest:
          "Klik Tambahkan Zona Baru untuk membuat Zona untuk Perkebunan ini.",
        locationZone: "Zona Lokasi",
        editFarmLocation: "Edit Lokasi Perkebunan",
        addZone: "Tambahkan Zona",
        nameOfTheZone: "Nama Zona",
        zoneDetails: "Detail Zona",
        perimeter: "Perimeter",
        areaUnit: "Unit Luas",
        area: "Luas",
        zoneName: "Nama Zona",
    
        farmGeofence: "Geofence Perkebunan",
        circularGeofence: "Geofence Lingkaran",
        polygonGeofence: "Geofence Poligon",
        
    
        actions: "Tindakan",
        editZone: "Edit Zona",
        numberOfGroups: "Jumlah Kelompok",
        numberOfTrees: "Jumlah Pohon",
        group: "Grup",
        groupName: "Nama Grup",
        numberOfAnimals: "Jumlah Hewan",
        status: "Status",
        primaryGeofence: "Geofence Utama",
        walkAndMeasure: "Jalan dan Ukur",
        clearGeofence: "Bersihkan Geofence",
        deleteSelectedVertex: "Hapus Titik Terpilih",
        basicInformation: "Informasi Dasar",
        geofenceCategoryName: "Nama Kategori Geofence",
        geofenceName: "Nama Geofence",
        farmRadius: "Radius Perkebunan",
        radiusInfo: "Menentukan jarak dari titik pusat ke tepi luar area melingkar.",
        radiusUnitInfo: "Mengacu pada jumlah standar yang digunakan sebagai dasar pengukuran.",
        locationDisabledMessage:
          "Lokasi Anda dinonaktifkan. Harap cari lokasi Anda dari menu kiri.",
        yourDistanceIs: "Jarak Anda adalah",
        activities: "Aktivitas",
        "search": "Cari",
        "selectCountry": "Pilih Negara",
        "filterByFarmName": "Filter Berdasarkan Nama Perkebunan",
        "filterByCropType": "Filter Berdasarkan Tipe Tanaman",
        "filterByStartDate": "Filter Berdasarkan Tanggal Mulai",
        "download": "Unduh",
        "of": "dari",
        "previousPage": "Halaman Sebelumnya",
        "nextPage": "Halaman Berikutnya",
        "view": "Lihat",
        "activityDetails": "Detail Aktivitas",
        "activity": "Aktivitas",
        "cropType": "Tipe Tanaman",
        "startDate": "Tanggal Mulai",
        "endDate": "Tanggal Akhir",
        "description": "Deskripsi",
        "close": "Tutup",
        "farmActivities": "Aktivitas Perkebunan",
        "listView": "Tampilan Daftar",
        "calendarView": "Tampilan Kalender",
        "scheduledActivities": "Aktivitas Terjadwal",
        "completedActivities": "Aktivitas Selesai",
        deforestationReports: "Laporan Deforestasi",
    
         "organic": "Organik",
      "conventional": "Konvensional",
    
        regBy: "Didaftarkan oleh",
        regDate: "Tanggal pendaftaran",
         selectFarmToEnableCalendarView: "Silakan pilih pertanian untuk mengaktifkan tampilan kalender",
        noFarm: "Tidak ada pertanian yang terdaftar.",
        noFarmDescription: "Silakan klik tombol di bawah ini untuk memulai.",
        searchFarmName: "Cari nama kebun",
        farmsAccessControl: "Kontrol Akses Perkebunan",
        chooseTheUserYouWantToManageFarmAccessFor: "Pilih pengguna(s) yang ingin Anda kontrol aksesnya.",
        selectTheFarmYouWantToManageAccessFor: "Pilih perkebunan yang ingin Anda kontrol aksesnya.",
        proceedWithSelected: "Lanjutkan dengan pilihan",
        userRole: "Peran Pengguna",
        userRoleInfo: "Peran pengguna. Peran pengguna menentukan izin yang ia miliki pada perkebunan.",
        usersSelected: "pengguna yang dipilih",
        viewFarmAccess: "Lihat Akses Perkebunan",
        selectUser: "Pilih Pengguna",
        recordsPerPage: "Rekaman per halaman",
        print: "Cetak",  
        custom: "Kustom",
        records: "Rekaman",
        dashboard: "Dasbor",
        accessControl: "Kontrol Akses",
        all: "Semua",
        farmer: "Petani",
        technician: "Teknisi",
        userNameAndId: "Nama Pengguna dan ID",
        email: "Email",
        userRoleAndRegDate: "Peran Pengguna dan Tanggal Pendaftaran",
        access: "Akses",
        active: "Aktif",
        inactive: "Tidak Aktif",
        na: "N/A",
        userDeactivated: "Pengguna Dinonaktifkan",
        userActivated: "Pengguna Diaktifkan",
        farmUsers: "Pengguna Perkebunan",
        viewAndUpdateTheFarmsThisUserHasAccessTo: "Lihat dan perbarui perkebunan yang pengguna ini memiliki akses ke",
        assignFarmsToTheSelectedUsers: "Tugaskan perkebunan kepada pengguna yang dipilih",
        selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Pilih perkebunan yang ingin Anda berikan akses kepada teknisi yang dipilih.",
        removeAccessFromSelectedFarms: "Hapus Akses dari Perkebunan yang Dipilih",
        grantFarmAccess: "Berikan Akses ke Perkebunan",
        back: "Kembali",
        s: "(s)",
        loadingData: "Memuat data...",
        selectFactory: "Pilih Pabrik",
        error: "Error",
        failedToLoadFarmsPleaseTryAgain: "Gagal memuat perkebunan. Silakan coba lagi.",
        removeAccess: "Hapus Akses",
        farmNameAndId: "Nama Perkebunan dan ID",
        removeFarmAccess: "Hapus Akses Perkebunan",
        grantAccess: "Berikan Akses ke Perkebunan",
        farmAccessGranted: "Akses Perkebunan Berhasil Diberikan",
        successfullyGrantedAccessTo: "Berhasil memberikan akses ke",
        farm: "perkebunan",
        for: "untuk",
        user: "pengguna",
        failedToGrantFarmAccessPleaseTryAgain: "Gagal memberikan akses ke perkebunan. Silakan coba lagi.",
        areYouSureYouWantToGrantAccessTo: "Apakah Anda yakin ingin memberikan akses ke",
        areYouSureYouWantToRemoveAccessFrom: "Apakah Anda yakin ingin menghapus akses dari",
        farmAccessRemoved: "Akses Perkebunan Dihapus",
        successfullyRemovedAccessFrom: "Berhasil menghapus akses dari",
        failedToRemoveFarmAccessPleaseTryAgain: "Gagal menghapus akses ke perkebunan. Silakan coba lagi.",
        forTheFollowingUsers: "untuk pengguna berikut?",
        selectFarm: "Pilih Perkebunan",
        farmAddedBy: "Perkebunan Ditambahkan Oleh",
        exportAsCSV: "Ekspor sebagai CSV",
        activityLog: "Log Aktivitas",


        youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "Anda berhasil membagikan akses perkebunan kepada pengguna berikut.",
        grantAccessToMoreUsers: "Berikan Akses ke Lebih Banyak Pengguna",
        areYouSureYouWantToRemoveAccessFor: "Apakah Anda yakin ingin menghapus akses untuk",
        thisUser: "pengguna ini",
        areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "Apakah Anda yakin ingin memberikan akses ke perkebunan ini untuk pengguna berikut?",
        failedToLoadUsersPleaseTryAgain: "Gagal memuat pengguna. Silakan coba lagi.",
        successfullyRemovedUserAccessFromThisFarm: "Berhasil menghapus akses pengguna dari perkebunan ini.",
        farmIdAndUserIdAreRequired: "ID Perkebunan dan ID Pengguna diperlukan.",
        noUsersSelectedPleaseSelectAtLeastOneUser: "Tidak ada pengguna yang dipilih. Silakan pilih setidaknya satu pengguna.",
        successfullyGrantedAccessToThisFarmFor: "Berhasil memberikan akses ke perkebunan ini untuk",
        unknownUser: "Pengguna Tidak Dikenal",
        confirm: "KONFIRMASI",
        farmActivityLog: "Log Aktivitas Perkebunan",
        ipAddress: "Alamat IP",
        dateAndTime: "Tanggal & Waktu",
        module: "Modul",
        activityDescription: "Deskripsi Aktivitas",
        select: "Pilih",
        addNewUsers: "Tambah Pengguna Baru",
        addUsersToFarm: "Tambah Pengguna ke Perkebunan",
        selectedUsers: "Pengguna yang Dipilih",
        selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Pilih pengguna yang akan ditambahkan ke perkebunan dari daftar semua pengguna di koperasi di bawah ini.",
        reviewTheSelectedUsersAndAssignTheirAccessRoles: "Tinjau pengguna yang dipilih dan tetapkan peran akses mereka.",
        allRoles: "Semua Peran",
        userRegistrationDate: "Tanggal Registrasi Pengguna",
        deactivated: "Dinonaktifkan",
        pleaseSelectAtLeastOneUser: "Silakan pilih setidaknya satu pengguna",
        noUsersSelected: "Tidak ada pengguna yang dipilih",
        userRemoved: "Pengguna dihapus",
        next: "BERIKUTNYA",
        id: "ID",
      },

      farm_upload_validation: {
        Farm_Upload_Validation: "Validasi Unggah Pertanian",
        Bulk_Upload_Field_Validation: "Validasi Bidang Unggah Massal",
        Go_Back: "Kembali",
        Input_Field: "Bidang Masukan",
        Validation_Message: "Pesan Validasi",
        Description: "Deskripsi",
        Action: "Aksi",
        Validate: "Validasi",
        Farm_Name: "Nama Pertanian",
        Farm_Registration_ID: "ID Registrasi Pertanian",
        Farmer_First_Name: "Nama Depan Petani",
        Farmer_Last_Name: "Nama Belakang Petani",
        Farmer_Registration_ID: "ID Registrasi Petani",
        User_Email_Address: "Alamat Email Pengguna",
        Shared_Access_With: "Berbagi Akses Dengan",
        Ownership_Type: "Jenis Kepemilikan",
        Goal_s: "Tujuan",
        Production_Type: "Jenis Produksi",
        Certifications: "Sertifikasi",
        Total_Farm_Size: "Ukuran Total Pertanian (misalnya, 50 hektar atau 20 hektar)",
        Farm_Address: "Alamat Pertanian",
        Farm_GPS_Coordinates: "Koordinat GPS Pertanian (misalnya, 40.7128, -74.0060)",
        Country: "Negara",
        Province_State: "Provinsi/Negara Bagian",
        Village_Town_City: "Desa/Kota",
        Farm_Geofence: "Geofence Pertanian (Poligon atau Lingkaran)",
        Helper_Messages: {
          Farm_Name: {
            Description: "Nama resmi pertanian yang terdaftar di otoritas atau dikenal secara publik.",
            Usage: "Nama ini digunakan untuk identifikasi dan branding."
          },
          Farm_Registration_ID: {
            Description: "Pengidentifikasi unik untuk registrasi pertanian.",
            Assignment: "Diberikan oleh badan pemerintah atau pertanian."
          },
          Farmer_First_Name: {
            Description: "Nama depan petani yang memiliki atau mengoperasikan pertanian.",
            Usage: "Ini digunakan untuk identifikasi pribadi dan dokumentasi hukum.",
            Instructions_1: "Masukkan nama depan petani.",
            Instructions_2: "Hindari singkatan, angka, atau karakter khusus.",
            Instructions_3: "Jika dibiarkan kosong, sistem akan menghasilkan 'Tidak Diketahui' sebagai nama depan."
          },
          Farmer_Last_Name: {
            Description: "Nama belakang (nama keluarga) petani.",
            Usage: "Ini digunakan untuk identifikasi pribadi dan dokumentasi hukum.",
            Instructions_1: "Masukkan nama belakang petani.",
            Instructions_2: "Hindari singkatan, angka, atau karakter khusus.",
            Instructions_3: "Periksa bahwa nama belakang sudah termasuk dan diformat dengan benar.",
            Instructions_4: "Jika dibiarkan kosong, sistem akan menghasilkan 'Tidak Diketahui' sebagai nama belakang."
          },
          Farmer_Registration_ID: {
            Description: "Pengidentifikasi unik untuk registrasi petani.",
            Assignment: "Biasanya diberikan oleh badan regulasi atau pertanian.",
            Usage: "ID ini digunakan untuk registrasi formal dan kepatuhan.",
            Instructions_1: "Masukkan ID Registrasi Petani untuk menghindari duplikasi.",
            Instructions_2: "Pastikan itu unik dan diformat dengan benar.",
            Instructions_3: "Jika dibiarkan kosong, sistem akan meminta Anda untuk menyediakannya untuk mencegah pembuatan entri duplikat (tidak wajib)."
          },
          User_Email_Address: {
            Description: "Ini adalah email dari pengguna yang akan ditugaskan ke pertanian atau akan memiliki akses utama ke pertanian.",
            Context: "Ini bisa berupa petani atau teknisi.",
            Usage: "Email ini digunakan untuk komunikasi, pemberitahuan, dan manajemen akun.",
            Instructions_1: "Masukkan email yang valid (misalnya, contoh@domain.com).",
            Instructions_2: "Periksa kesalahan ketik dan spasi.",
            Instructions_3: "Verifikasi format email sudah benar.",
            Instructions_4: "Jika dibiarkan kosong, sistem harus meminta pengguna untuk menyediakan email yang valid (tidak wajib)."
          },
          Shared_Access_With: {
            Description: "Menentukan individu atau entitas dengan siapa akses ke data pertanian dibagikan.",
            Usage: "Memungkinkan kolaborasi yang terkontrol berdasarkan peran dan tanggung jawab."
          },
          Ownership_Type: {
            Description: "Menunjukkan jenis kepemilikan pertanian.",
            Examples: "Contoh termasuk individu, kemitraan, atau korporasi.",
            Usage: "Ini untuk tujuan hukum dan administratif."
          },
          Goal_s: {
            Description: "Menggambarkan tujuan utama pertanian."
          },
          Production_Type: {
            Description: "Menunjukkan aktivitas pertanian utama dari pertanian, seperti organik atau konvensional."
          },
          Certifications: {
            Description: "Pilih sertifikasi yang terkait dengan pertanian, seperti sertifikasi organik, perdagangan adil, atau GAP."
          },
          Total_Farm_Size: {
            Description: "Luas total pertanian (hektar atau hektar). Digunakan untuk perencanaan sumber daya, pelaporan regulasi, dan analisis pasar."
          },
          Farm_Address: {
            Description: "Masukkan alamat lengkap pertanian, termasuk alamat jalan, kota, negara bagian, dan kode pos. Digunakan untuk identifikasi lokasi dan pengiriman layanan."
          },
          Farm_GPS_Coordinates: {
            Description: "Koordinat geografis (lintang dan bujur) dari lokasi pertanian. Membantu dalam menemukan pertanian di peta."
          },
          Country: {
            Description: "Negara tempat pertanian berada."
          },
          Province_State: {
            Description: "Provinsi atau negara bagian tempat pertanian berada. Opsi tergantung pada negara yang dipilih."
          },
          Village_Town_City: {
            Description: "Desa, kota, atau kota tempat pertanian berada."
          },
          Farm_Geofence: {
            Description: "Pemetaan geofence dari pertanian mencakup batas-batas pertanian di peta. Menentukan batas pertanian menggunakan geofence (poligon atau lingkaran)."
          }
        },
        validation: {
          farmNameRequired: "Nama pertanian diperlukan",
          farmNameMaxLength: "Nama pertanian harus kurang dari 50 karakter",
          farmNameExists: "Nama pertanian sudah ada",
          registrationIDRequired: "ID registrasi diperlukan",
          registrationIDMaxLength: "ID registrasi harus kurang dari 20 karakter",
          firstNameRequired: "Nama depan petani diperlukan",
          firstNameLettersOnly: "Nama depan harus hanya berisi huruf",
          lastNameRequired: "Nama belakang petani diperlukan",
          lastNameLettersOnly: "Nama belakang harus hanya berisi huruf",
          emailRequired: "Email diperlukan",
          emailValid: "Masukkan email yang valid (misalnya, contoh@domain.com)",
          emailNoSpaces: "Email tidak boleh mengandung spasi",
          sharedAccessWithRequired: "Silakan pilih setidaknya satu entitas atau biarkan kosong",
          ownershipTypeRequired: 'Jenis kepemilikan diperlukan atau akan default ke "Tidak Diketahui"',
          farmGoalsMaxLength: "Tujuan pertanian harus kurang dari 500 karakter",
          productionTypeRequired: "Silakan pilih jenis produksi atau biarkan kosong",
          certificationsRequired: "Silakan pilih setidaknya satu entitas atau biarkan kosong",
          farmSizePositive: "Ukuran pertanian harus berupa nilai numerik positif",
          farmSizeUnit: "Tentukan unit (misalnya, 50 hektar atau 20 hektar)",
          farmAddressFormat: "Alamat tidak valid. Format: Jalan, Kota, Negara Bagian, Kode Pos",
          farmGPSCoordinatesFormat: "Koordinat GPS tidak valid. Format: Lintang, Bujur (misalnya, 40.7128, -74.0060)",
          countryRequired: "Negara diperlukan",
          countryLettersOnly: "Nama negara harus hanya berisi huruf",
          provinceStateRequired: "Provinsi/Negara Bagian diperlukan",
          provinceStateLettersOnly: "Provinsi/Negara Bagian harus hanya berisi huruf",
          villageTownCityRequired: "Desa/Kota diperlukan",
          villageTownCityLettersOnly: "Desa/Kota harus hanya berisi huruf",
          farmGeofencePolygon: "Titik poligon tidak valid. Format: Pasangan Lintang, Bujur",
          farmGeofenceCircle: "Geofence tidak valid. Format: Lintang, Bujur Pusat; Area dalam hektar"
        }
      },
}